import * as React from "react";

function X(props) {
  return (
    <svg viewBox="0 0 30 30" aria-label="X logo" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clip-path="url(#clip0_704_56)">
        <path d="M15 0.00488281C23.2787 0.00488281 30 6.72617 30 15.0049C30 23.2836 23.2787 30.0049 15 30.0049C6.72129 30.0049 0 23.2836 0 15.0049C0 6.72617 6.72129 0.00488281 15 0.00488281Z" fill="black" />
        <path d="M21.7355 21.4114L16.4646 13.754L15.8685 12.888L12.0979 7.41009L11.7856 6.9563H7.15234L8.28242 8.59852L13.2956 15.8828L13.8917 16.7479L17.92 22.6007L18.2323 23.0541H22.8656L21.7355 21.4118V21.4114ZM18.7831 22.0054L14.5982 15.9251L14.0021 15.0595L9.14593 8.0041H11.2348L15.162 13.7099L15.7581 14.5755L20.872 22.0054H18.7831Z" fill="white" />
        <path d="M14.0021 15.0596L14.5982 15.9252L13.8917 16.7476L8.47131 23.0537H7.13428L13.2956 15.8824L14.0021 15.0596Z" fill="white" />
        <path d="M22.3078 6.9563L16.4647 13.754L15.7582 14.5759L15.1621 13.7103L15.8686 12.888L19.8268 8.28116L20.9712 6.9563H22.3078Z" fill="white" />
      </g>
      <defs>
        <clipPath id="clip0_704_56">
          <rect width="30" height="30" fill="white" transform="translate(0 0.00488281)" />
        </clipPath>
      </defs>
    </svg>

  );
}

export default X;